export default "__VITE_ASSET__ChV1DvTJ__"